import React from 'react';

const GROUP_LABELS = {
  company_profile: ['Unternehmensprofil', 'Company profile'],
  business_address: ['Geschäftsanschrift', 'Business address'],
  commercial_register: ['Registerangaben', 'Commercial register'],
  tax_details: ['Steuerangaben', 'Tax details'],
  founding: ['Gründungsabschluss', 'Founding completion'],
};

const STATUS_LABELS = {
  pending: ['Prüfung läuft', 'Under review'],
  approved: ['Freigegeben', 'Approved'],
  rejected: ['Nicht freigegeben', 'Not approved'],
  unknown: ['Status ungeklärt', 'Status unknown'],
};

function formatHistoryDate(value, language) {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString(language === 'en' ? 'en-GB' : 'de-DE', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export default function CompanyDataChangeHistory({ items = [], language = 'de', showCustomer = false }) {
  const index = language === 'en' ? 1 : 0;
  const copy = (de, en) => (index === 1 ? en : de);
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <section className="company-change-history" aria-labelledby="company-change-history-title">
      <div className="company-change-history__heading">
        <div>
          <span className="eyebrow">{copy('Nachvollziehbar & datensparsam', 'Traceable & data-minimised')}</span>
          <h3 id="company-change-history-title">{copy('Änderungsverlauf', 'Change history')}</h3>
        </div>
        <span className="company-change-history__count">
          {safeItems.length} {copy(safeItems.length === 1 ? 'Vorgang' : 'Vorgänge', safeItems.length === 1 ? 'change' : 'changes')}
        </span>
      </div>
      <p className="field-hint">
        {copy(
          'Angezeigt werden nur Zeitpunkt, betroffene Bereiche und Freigabestatus. Frühere oder neue Einzelwerte werden hier bewusst nicht wiedergegeben.',
          'Only the time, affected areas and approval status are shown. Previous and new individual values are deliberately not repeated here.'
        )}
      </p>

      {safeItems.length === 0 ? (
        <div className="info-box">{copy('Noch keine Unternehmensdatenänderung vorhanden.', 'No company data changes are available yet.')}</div>
      ) : (
        <ol className="company-change-history__list">
          {safeItems.map((item) => {
            const statusLabels = STATUS_LABELS[item.status] || STATUS_LABELS.unknown;
            const groups = Array.isArray(item.field_groups) ? item.field_groups : [];
            return (
              <li key={item.id} className={`company-change-history__item company-change-history__item--${item.status || 'unknown'}`}>
                <div className="company-change-history__item-heading">
                  <div>
                    {showCustomer && item.customer ? <strong>{item.customer.label}</strong> : null}
                    <span>{item.request_type === 'founding_completion'
                      ? copy('Gründungsdaten eingereicht', 'Founding details submitted')
                      : copy('Unternehmensdaten geändert', 'Company details changed')}</span>
                  </div>
                  <span className={`company-change-history__status company-change-history__status--${item.status || 'unknown'}`}>
                    {statusLabels[index]}
                  </span>
                </div>
                <div className="company-change-history__meta">
                  <span>{copy('Eingereicht', 'Submitted')}: <strong>{formatHistoryDate(item.submitted_at, language)}</strong></span>
                  {item.reviewed_at ? <span>{copy('Geprüft', 'Reviewed')}: <strong>{formatHistoryDate(item.reviewed_at, language)}</strong></span> : null}
                </div>
                <div className="company-change-history__groups" aria-label={copy('Betroffene Bereiche', 'Affected areas')}>
                  {groups.length ? groups.map((group) => (
                    <span key={group}>{(GROUP_LABELS[group] || [group, group])[index]}</span>
                  )) : <span>{copy('Keine Feldgruppe ausgewiesen', 'No field group recorded')}</span>}
                </div>
                {item.approval_confirmed ? (
                  <p className="company-change-history__approval">✓ {copy('Freigabe ist bestätigt.', 'Approval is confirmed.')}</p>
                ) : null}
              </li>
            );
          })}
        </ol>
      )}
    </section>
  );
}
